module.exports = __webpack_public_path__ + "img/bobux_bobocoin.gm.fce3330.png";